import { render, staticRenderFns } from "./DropdownLang.vue?vue&type=template&id=d66978bc&scoped=true&"
import script from "./DropdownLang.vue?vue&type=script&lang=js&"
export * from "./DropdownLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66978bc",
  null
  
)

export default component.exports